/**
 * This is experimental component, can change in the future.
 *
 * Usage: Pass the component to "as" property of headlessui components
 *
 * Example:
 * <Listbox as={Dropdown}>
 *   <ListboxOption as={DropdownItem}>
 *     ...
 *   </ListboxOption>
 * </Listbox>
 */

import { forwardRef } from "react";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { MenuItemsProps } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";

export const Dropdown = forwardRef<
  HTMLDivElement,
  { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={twMerge(
        "decideScrollbar relative z-10 w-75 origin-top overflow-hidden rounded-lg bg-white py-2 shadow-lg",
        "transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0",
        props.className,
      )}
    >
      {children}
    </div>
  );
});

export const DropdownItem = forwardRef<
  HTMLDivElement,
  { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      className={twMerge(
        "flex h-12 min-w-[17rem] cursor-pointer items-center justify-between px-4 py-2.5",
        "ui-active:bg-gray-50 hover:bg-gray-50",
        "font-inter-normal-13px text-gray-800",
        "data-[disabled]:pointer-events-none data-[disabled]:cursor-default data-[disabled]:text-gray-400",

        // divider
        "has-[hr]:h-auto",

        "group select-none",
        props.className,
      )}
    >
      {children}
      <div className="hidden group-data-[selected]:block">
        <Icon color="text-indigo-500" icon={faCheck} size="sm" />
      </div>
    </div>
  );
});

type AnchorProps = MenuItemsProps["anchor"];
export type DropdownPlacement = Exclude<
  AnchorProps,
  false | string | undefined
>["to"];
